<template>
  <Teleport to="body">
    <Transition name="popup-slide">
      <div v-if="isOpen" class="admin-popup-wrapper" v-bind="$attrs">
        <div class="popup-content" :style="adPopupStyle" :class="adClass">
          <div v-if="props.title || props.showCloseButton || $slots.header" class="popup-header">
            <slot name="header">
              <h3 v-if="props.title" class="modal-title">{{ props.title }}</h3>
            </slot>
            <button type="button" v-if="showCloseButton" class="close-btn" @click="emit('close')"></button>
          </div>
          <div class="popup-body" v-html="content"></div>
          <div v-if="$slots.footer" class="popup-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>
<script lang="ts" setup>
import type { CSSProperties } from 'vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '',
    required: false
  },
  content: {
    type: String,
    default: ''
  },
  adClass: {
    type: String,
    default: '',
    required: false
  },
  showCloseButton: {
    type: Boolean,
    default: false
  },
  top: {
    type: Number,
    default: null,
    required: false
  },
  left: {
    type: Number,
    default: null,
    required: false
  },
  width: {
    type: Number,
    default: null,
    required: false
  },
  height: {
    type: Number,
    default: null,
    required: false
  }
})

// 닫기 이벤트 정의
const emit = defineEmits<{
  (e: 'close'): void
}>()

// 좌표값이 있을 때만 적용
const adPopupStyle = computed((): CSSProperties => {
  if (!props.top !== undefined && props.left !== undefined && props.width !== undefined && props.height !== undefined) {
    return {
      top: typeof props.top === 'number' ? `${props.top}px` : props.top,
      left: typeof props.left === 'number' ? `${props.left}px` : props.left,
      width: typeof props.width === 'number' ? `${props.width}px` : props.width,
      height: typeof props.height === 'number' ? `${props.height}px` : props.height,
      position: 'fixed',
      margin: '0',
      transform: 'none'
    }
  }

  // 좌표값 없을 때 기본 중앙 정렬 적용
  return {}
})

// Teleport 사용시 부모의 속성이 루트에 자동 상속되어 꼬이지 않도록 설정
defineOptions({
  inheritAttrs: false
})
</script>
<style lang="scss" scoped>
  
</style>